// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"03323cd4","51":"74285218","239":"ef9909eb","453":"6ed1eb1c","455":"a1b7652e","767":"0dceaf93","781":"bc71ad81","804":"58218611","821":"a96e9fea","928":"07f4dc7b"}[chunkId] + ".chunk.js";
};